import React from "react";
import accordionScrollImg from "./../../../img/icons/Accordion-stickyscroll-icon.svg";
import Share from "../../Share";
import ExcelDownload from "../../ExcelDownload";
import { useSelector } from "react-redux";
import { AddMyAnalogModalIcon } from "../../AddToMyAnalogIcon/AddToMyAnalogIcon";

const Tools = ({ isSticky, tableName, handleScrollTop }) => {
    const jsonData = useSelector( (state) => state.filters.quickFilter );
  return (
    <div className="tools-section">
      {isSticky && jsonData && Object.keys(jsonData).length > 0 ? (
        <img
          src={accordionScrollImg}
          alt="Sticky Accordion Icon"
          onClick={handleScrollTop}
        />
      ) : null}
      <AddMyAnalogModalIcon tableName={tableName} mobile />
      <ExcelDownload />
      <Share />
    </div>
  );
};

export default Tools;